import { scrollTo } from 'ui/animation';
import { lazyPageFeatureRequests, triggerEvent } from 'utilities/dom';

// Smoothly scrolls to section on pdp with sticky header offset
const scrollToSection = (elem) => {

	const $section = $(elem);

	if ($section.length) {

		triggerEvent.call(document, 'loadLazyPageFeatures');
		Promise.all(lazyPageFeatureRequests).then(() => {

			const stickyHeaderHeight = $('[data-stickyheader]').length ? $('[data-stickyheader]').outerHeight() - 1 : 0;
			const scrollTop = $section.offset().top - stickyHeaderHeight;
			scrollTo(200, scrollTop);

		});

	}

};

export default scrollToSection;
